var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var _a;
import { makeAutoObservable } from "mobx";
import { perRestaurant } from "../di";
import { translate, t } from "../I18n";
import { FulfillmentTimeScope } from "../ordering";
let NotAvailableFulfillmentMethodLabel = class NotAvailableFulfillmentMethodLabel {
    constructor(fulfillmentTimeScope) {
        this.fulfillmentTimeScope = fulfillmentTimeScope;
        makeAutoObservable(this);
    }
    mkLabel(messageKey) {
        return {
            message: translate(messageKey),
            enabledOnClick: false,
            type: "error",
        };
    }
    label(view, unavailabilityCausingParameters) {
        if (view === "Cart" || this.fulfillmentTimeScope.fulfillmentTime === null) {
            return null;
        }
        const { fulfillmentMethod } = unavailabilityCausingParameters.internal;
        if (fulfillmentMethod.includes("Delivery")) {
            return this.mkLabel(t.client.labels.not_available_fulfillment_method.delivery);
        }
        if (fulfillmentMethod.includes("Takeaway")) {
            return this.mkLabel(t.client.labels.not_available_fulfillment_method.takeway);
        }
        if (fulfillmentMethod.includes("DineIn")) {
            return this.mkLabel(t.client.labels.not_available_fulfillment_method.dinein);
        }
        return null;
    }
};
NotAvailableFulfillmentMethodLabel = __decorate([
    perRestaurant(),
    __metadata("design:paramtypes", [typeof (_a = typeof FulfillmentTimeScope !== "undefined" && FulfillmentTimeScope) === "function" ? _a : Object])
], NotAvailableFulfillmentMethodLabel);
export { NotAvailableFulfillmentMethodLabel };
